import React from "react";
import { CheckCircle, Clock, AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";

interface StageCardProps {
  title: string;
  status: "completed" | "current" | "upcoming";
  description: string;
  details?: string;
}

const StageCard: React.FC<StageCardProps> = ({
  title,
  status,
  description,
  details,
}) => {
  return (
    <div className="flex items-start p-3 md:p-4 border rounded-lg">
      <div className="mr-3 md:mr-4 mt-1 flex-shrink-0">
        {status === "completed" && (
          <CheckCircle className="h-5 w-5 md:h-6 md:w-6 text-green-500" />
        )}
        {status === "current" && (
          <Clock className="h-5 w-5 md:h-6 md:w-6 text-honeycomb" />
        )}
        {status === "upcoming" && (
          <AlertTriangle className="h-5 w-5 md:h-6 md:w-6 text-gray-300" />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <h3
          className={cn(
            "font-medium text-sm md:text-base",
            status === "current"
              ? "text-honeycomb"
              : status === "completed"
              ? "text-green-700"
              : "text-gray-400"
          )}
        >
          {title}
        </h3>
        <p className="text-xs md:text-sm text-gray-500 mt-1">{description}</p>
        {details && (
          <p className="text-xs md:text-sm font-medium mt-1 break-words">
            {details}
          </p>
        )}
      </div>
      <div className="ml-2 md:ml-auto flex-shrink-0">
        {status === "completed" && (
          <span className="inline-flex items-center px-2 py-1 rounded-full text-[10px] md:text-xs font-medium bg-green-100 text-green-800">
            Completed
          </span>
        )}
        {status === "current" && (
          <span className="inline-flex items-center px-2 py-1 rounded-full text-[10px] md:text-xs font-medium bg-amber-100 text-amber-800">
            In Progress
          </span>
        )}
      </div>
    </div>
  );
};

export default StageCard;
